import { ScrollContainer } from '../../ScrollContainer'

import * as styles from './SelectDropdownListContainer.module.css'

function SelectDropdownListContainer({
  Element = ScrollContainer,
  children,
  className = styles.SelectDropdownListContainer,
  ...restProps
}) {
  return (
    <Element {...restProps} className={className}>
      {children}
    </Element>
  )
}

export default SelectDropdownListContainer
